function Home() {
  // const pageTab = "home";

  return (
    <div className={"Home GridTemplate12"}>
      
    </div>
  );
}

export default Home;